"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const analiseSignalService = {
  get: function (options) {
    return api.get("/Analises/Signals", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getSimpleSignals: function (options) {
    return api.get("/Analises/SimpleSignals", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default analiseSignalService;
